<template>
  <div class="master-select">
    <label :for="name">{{ label }}</label>
    <select v-model="selected" :id="name" :disabled="disabled">
      <option value="">-- {{ placeholder }} --</option>
      <option v-for="item in items" :key="item[idKey]" :value="+item[idKey]">
        {{ formatItem(item) }}
      </option>
    </select>

    <!-- Inline add toggle -->
    <button type="button" :disabled="disabled" @click="!disabled && (showAdd = !showAdd)">
      {{ showAdd ? "إلغاء" : "إضافة" }}
    </button>

    <div v-if="showAdd" class="inline-add">
      <input
        v-for="field in fields"
        :key="field.name"
        v-model="newItem[field.name]"
        :placeholder="field.label"
      />
      <button type="button" @click="createNew">حفظ</button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue"
import axios from "axios"

const props = defineProps({
  endpoint: { type: String, required: true }, // "/api/companies"
  idKey: { type: String, required: true },    // "company_id"
  label: { type: String, required: true },
  name: { type: String, required: true },
  fields: { type: Array, required: true },    // [{ name: "company_name", label: "اسم الشركة" }]
  placeholder: { type: String, default: "اختر قيمة" },
  formatItem: { type: Function, default: (i) => JSON.stringify(i) },
  modelValue: [String, Number],
  disabled: { type: Boolean, default: false },
  // extraPayload can be an object or a function returning an object
  extraPayload: { type: [Object, Function], default: null }
})

const emit = defineEmits(["update:modelValue"])
const selected = ref(props.modelValue ?? "")
const items = ref([])
const showAdd = ref(false)
const newItem = ref({})

watch(selected, (val) => emit("update:modelValue", val))
watch(() => props.modelValue, (v) => {
  selected.value = v ?? ""      // coerce null/undefined to ""
})

async function fetchItems() {
  if (props.disabled) { items.value = []; return }
  const res = await axios.get(props.endpoint)
  items.value = res.data
}

async function createNew() {
  if (props.disabled) return
  try {
    const extra =
      typeof props.extraPayload === "function"
        ? props.extraPayload()
        : (props.extraPayload || {})
    if ('company_id' in extra && !extra.company_id) {
      alert("يرجى اختيار الشركة أولاً")
      return
    }
    const payload = { ...newItem.value, ...extra }
    const res = await axios.post(props.endpoint, payload)

    showAdd.value = false
    newItem.value = {}
    await fetchItems()
    selected.value = res.data[props.idKey]
  } catch (err) {
    alert(err.response?.data?.detail || "Error adding item")
  }
}

onMounted(fetchItems)
watch(() => props.endpoint, fetchItems)
watch(() => props.disabled, fetchItems)
</script>

<style scoped>
.master-select {
  margin-bottom: 1rem;
}
.inline-add {
  margin-top: 0.5rem;
}
</style>
